import Vue from 'vue';
import parseData from './data-parser';

export default function formSubmitHandlerFactory ($newsForm, NewsVM) {
    let previousRequest = null;
    return function (e) {
        e.preventDefault();
        Vue.set(NewsVM.data, 'loading', true);

        if (previousRequest) previousRequest.abort();

        previousRequest = $.ajax({
            method: $newsForm.attr('method'),
            url: $newsForm.attr('action'),
            data: $newsForm.serialize(),
        }).then((data) => {
            previousRequest = null;
            const parsedData = parseData(data);

            Vue.set(NewsVM.data, 'results', parsedData.results);
            Vue.set(NewsVM.data, 'total', parsedData.total);
            Vue.set(NewsVM.data, 'loading', false);
            Vue.set(NewsVM.data, 'error', null);
        }).catch(err => {
            previousRequest = null;

            console.error(err);
            Vue.set(NewsVM.data, 'loading', false);
            Vue.set(NewsVM.data, 'error', err.message);
        });
    }
}
